export const DAY_MODE = 'day';
export const CALENDAR_MODE = 'calendar';